import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { type AcquisitionCommissionSummary } from '@/domain/acquisition/types';
import { formatCommission } from '@/domain/acquisition/utils';
import { useTranslate } from '@/state/i18n';
import { radiusTokens } from '@/theme/themePrimitives';

interface Props {
  summary: AcquisitionCommissionSummary;
}

/** Commissions of every link since the start (not only the window): to receive and paid. */
const CommissionSummaryCard = ({ summary }: Props) => {
  const t = useTranslate('domain.acquisition.components.CommissionSummaryCard');

  return (
    <Paper variant="outlined" sx={sx.paper}>
      <Typography variant="subtitle2" fontWeight={700}>
        {t('title')}
      </Typography>
      <Stack divider={<Divider />} gap={1.5}>
        <Stack gap={0.25}>
          <Typography variant="caption" color="text.secondary">
            {t('toReceive')}
          </Typography>
          <Typography variant="h3" component="p">
            {formatCommission(summary.toReceiveCents)}
          </Typography>
        </Stack>
        <Stack gap={0.25}>
          <Typography variant="caption" color="text.secondary">
            {t('paid')}
          </Typography>
          <Typography variant="h3" component="p">
            {formatCommission(summary.paidCents)}
          </Typography>
        </Stack>
      </Stack>
      <Typography variant="caption" color="text.secondary">
        {t('hint')}
      </Typography>
    </Paper>
  );
};

export default CommissionSummaryCard;

const sx = {
  paper: {
    borderRadius: radiusTokens.xxl,
    p: 2.5,
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
  },
};
